/**
 * Wrapper around `startSwissPassLogin` that saves the current application state
 * before triggering the SwissPass OAuth redirect.
 */

import { isSessionRestoreEnabled } from "../sessionRestore/sessionRestore.config";
import { sessionRestoreService } from "../sessionRestore/SessionRestoreService";
import { startSwissPassLogin } from "./swisspass-login.service";

/**
 * Captures the current planner session (when enabled) and starts SwissPass login.
 *
 * @returns Resolves once navigation is triggered (page unload follows).
 */
export async function startSwissPassLoginWithStateSave(): Promise<void> {
    if ( isSessionRestoreEnabled() ) {
        sessionRestoreService.saveAppState();
    }

    await startSwissPassLogin();
}
